import { useEffect } from 'react'
import { useThemeStore, resolveTheme } from '@/stores/theme-store'
import { useUserTimezone } from '@/hooks/use-user-timezone'

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const mode = useThemeStore((s) => s.mode)
  const schedule = useThemeStore((s) => s.schedule)
  const activeDashboard = useThemeStore((s) => s.activeDashboard)
  const dashboardOverrides = useThemeStore((s) => s.dashboardOverrides)
  const setResolvedTheme = useThemeStore((s) => s.setResolvedTheme)
  const setSchedule = useThemeStore((s) => s.setSchedule)
  const { timezone, isLoaded } = useUserTimezone()

  // The theme schedule follows the user's single time zone setting.
  useEffect(() => {
    if (isLoaded && schedule.timezone !== timezone) setSchedule({ timezone })
  }, [isLoaded, timezone, schedule.timezone, setSchedule])

  useEffect(() => {
    function applyTheme() {
      const resolved = resolveTheme(mode, schedule, activeDashboard, dashboardOverrides)
      setResolvedTheme(resolved)

      if (resolved === 'dark') {
        document.documentElement.classList.add('dark')
      } else {
        document.documentElement.classList.remove('dark')
      }
    }

    applyTheme()

    // Re-check every 60 seconds for auto mode schedule changes
    const interval = setInterval(applyTheme, 60_000)
    return () => clearInterval(interval)
  }, [mode, schedule, activeDashboard, dashboardOverrides, setResolvedTheme])

  return <>{children}</>
}
